module.exports = __webpack_public_path__ + "static/media/search@2x.dea16f39.png";